<template>
  <router-view />
</template>

<script>
export default {
  name: 'EmptyWrapper',
};
</script>
